import {
  AlertProvider,
  ThemeProvider,
  ToastProvider,
  TooltipProvider
} from "@prismicio/editor-ui"
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
  ScrollRestoration
} from "react-router-dom"

import { ExistingDocument, NewDocument } from "../document"
import { DocumentList } from "../documents/DocumentList"
import { ReleasePage } from "../documents/releases/ReleasePage"
import { ReleasesList } from "../documents/releases/ReleasesList"
import { MediaLibraryPage } from "../medias/MediaLibraryPage"
import { AppErrorHandler, RouterError } from "./AppErrorHandler"
import { AppSuspense } from "./AppSuspense"
import { ExperimentsSupport } from "./experiments"
import { IntercomSupport } from "./intercom"
import { getRouterBasename } from "./routing"

export function App() {
  return (
    <ThemeProvider mode="light">
      <AppErrorHandler>
        <AppSuspense>
          <AlertProvider>
            <ToastProvider>
              <TooltipProvider>
                <IntercomSupport>
                  <ExperimentsSupport>
                    <RouterProvider
                      router={router}
                      future={{ v7_startTransition: true }}
                    />
                  </ExperimentsSupport>
                </IntercomSupport>
              </TooltipProvider>
            </ToastProvider>
          </AlertProvider>
        </AppSuspense>
      </AppErrorHandler>
    </ThemeProvider>
  )
}

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <RootRoute />,
      errorElement: <RouterError />,
      children: [
        {
          path: "/",
          element: <Navigate to="working" replace />
        },
        {
          path: "working",
          element: <DocumentList tab="working" />
        },
        {
          path: "upcoming",
          element: <ReleasesList />
        },
        {
          path: "upcoming/:releaseId",
          element: <ReleasePage />
        },
        {
          path: "archived",
          element: <DocumentList tab="archived" />
        },
        {
          path: "medias",
          element: <MediaLibraryPage />
        },
        {
          path: "pages/:documentId",
          element: <ExistingDocument />
        },
        {
          path: "pages/new",
          element: <NewDocument />
        }
      ]
    }
  ],
  { basename: getRouterBasename() }
)

// Pure logic parent of all other routes.
// This shouldn't add any default/shared view/chrome, App can do that.
// Only using this to install scroll restoration across all routes, as ScrollRestoration must be a child of the router.
function RootRoute() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  )
}
